import { render, staticRenderFns } from "./OnboardingSettings.vue?vue&type=template&id=8f8b3d0a"
import script from "./OnboardingSettings.vue?vue&type=script&lang=js"
export * from "./OnboardingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports